import '@fontsource/cairo';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './i18n/config';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';

// إلغاء تسجيل Service Workers القديمة على localhost لتفادي استخدام مفاتيح Firebase المنتهية
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && /localhost|127\.0\.0\.1/.test(window.location.host)) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

// Ignore MetaMask/extension unhandled rejections so they don't trigger React error overlay
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message ?? String(event.reason ?? '');
    if (/MetaMask|extension not found|chrome-extension/i.test(msg)) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  window.addEventListener('error', (ev) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[global error]', ev.message, ev.filename, ev.lineno);
    }
  });

  // WebView: في الإنتاج نعيد true لتقليل تعطيل الصفحة؛ في التطوير false ليظهر overlay الأخطاء
  window.onerror = function onOpenAuctionError(msg, url, lineNo, columnNo, error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[window.onerror]', msg, url, lineNo, columnNo, error);
      return false;
    }
    console.warn('[window.onerror]', String(msg));
    return true;
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            fontFamily: 'inherit',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
  </BrowserRouter>
);